import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { DeliveryCity } from '../types/delivery-city.type';
import { ADMIN_DELIVERY_CITIES_API_PATHS } from '../constants/delivery-cities-api-paths.constants';

type UseRestoreDeliveryCityResult = {
  restoreDeliveryCity: (deliveryCityId: string) => Promise<DeliveryCity | null>;
  isSubmitting: boolean;
};

export function useRestoreDeliveryCity(): UseRestoreDeliveryCityResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const restoreDeliveryCity = async (deliveryCityId: string): Promise<DeliveryCity | null> => {
    setIsSubmitting(true);

    try {
      const restoredDeliveryCity = await HttpClient.post<DeliveryCity>(
        ADMIN_DELIVERY_CITIES_API_PATHS.RESTORE_DELIVERY_CITY(deliveryCityId)
      );

      enqueueSnackbar('Ville de livraison restaurée', { variant: 'success' });
      return restoredDeliveryCity;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(
          error,
          'Une erreur est survenue lors de la restauration de la ville de livraison'
        ),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { restoreDeliveryCity, isSubmitting };
}
